import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import footer_icon1 from '../../img/footer_icon1.svg';
import footer_icon2 from '../../img/footer_icon2.svg';
import footer_icon3 from '../../img/footer_icon3.svg';
import footer_icon4 from '../../img/footer_icon4.svg';
import footer_icon5 from '../../img/footer_icon5.svg';

import { Big3Common, bootstrap } from "../../js/IncludeManager";
import { Alert } from '../../js/ComponentManager'


/**
 * 개발담당:양유빈
 * 화면기능:공통 풋터 화면
 **/
export class Footer extends Component {
    static displayName = Footer.name;

    constructor(props) {
        super(props);
        this.state = {
            Conf_Count: 0,
            Jm_Count: 0,
            fillName:""
        };
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    componentDidMount() {
        this.CallGetFooterCount();
    }
    CallGetFooterCount = async () => {

        try {
            let Data = await Big3Common.Get(`api/Common/Common/GetFooterCount`);
            const fillName = this.props.fillName !== null ? this.props.fillName : "";
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);                
                if (DataList.length > 0) {
                    const Jm_Count = DataList[0]["jm_count"] + DataList[0]["order_count"];
                    this.setState({
                        Conf_Count: DataList[0]["conf_count"],
                        Jm_Count: Jm_Count,
                        fillName: fillName
                    });
                }
                else {
                    this.setState({
                        fillName: fillName
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGetFooterCount: ", e)
        }
    }
    //로그기록
    handle_Click = () => {
        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "MB",
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
    }
    handleAlert() {
        this.setState({
            Title: "택배주문안내",
            Content: "택배주문은 장바구니에서 가능합니다."
        });
        Big3Common.ModalAlert(bootstrap, 'Delivery');
    }
    footer_textrender(icon,Name) {
        return (
            <div className={this.state.fillName === icon ? "footer_txt check_on" : "footer_txt"}>{Name}</div>
        )
    }
  
    render() {
        return (
            <div>
                <Alert
                    id="Delivery"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <footer>
                    <ul>
                        <li>
                            <Link to="/MyPage/BookMark/Index">
                                <div className="footer_icon">
                                    <img src={footer_icon3} alt="찜아이콘" className={this.state.fillName === "icon3" ? "fill" : ""} />
                                </div>
                            </Link>
                            {this.footer_textrender("icon3","찜")}
                        </li>
                        <li>
                            {this.Uid_Type === 'SS' ?
                                <div onClick={() => { this.handle_Click() }}>
                                    <Link to="/Order/Store/Index">
                                        <div className="footer_icon">
                                            <img src={footer_icon2} alt="거래처아이콘" className={this.state.fillName === "icon2" ? "fill" : ""} />
                                        </div>
                                    </Link>
                                    {this.footer_textrender("icon2", "사입주문")}
                                </div>
                            : 
                                <div onClick={() => { this.handle_Click() }}>
                                    <Link to="/Order/Store/Index">
                                        <div className="footer_icon">
                                            <img src={footer_icon2} alt="거래처아이콘" className={this.state.fillName === "icon2" ? "fill" : ""} />
                                        </div>
                                    </Link>
                                    {this.footer_textrender("icon2", "픽업요청")}
                                </div>
                            }
                        </li>
                        <li>
                            <Link to="/">
                                <div className="footer_icon">
                                    <img src={footer_icon1} alt="홈아이콘" className={this.state.fillName === "icon1" ? "fill" : ""} />
                                </div>
                            </Link>
                            {this.footer_textrender("icon1", "홈")}
                        </li>
                        <li>
                            <Link to="/Chat/ChatList/Index">
                                <div className="footer_icon">
                                    <img src={footer_icon4} alt="문의하기아이콘" className={this.state.fillName === "icon4" ? "fill" : ""} />
                                    {this.state.Conf_Count === 0 ? "" : <p className="f_new"></p>}
                                </div>
                            </Link>
                            {this.footer_textrender("icon4", "문의하기")}
                        </li>
                        <li>
                            <Link to="/MyPage/MyInfoMgr/Index">
                                <div className="footer_icon">
                                    <img src={footer_icon5} alt="내정보아이콘" className={this.state.fillName === "icon5" ? "fill" : ""} />
                                    {this.state.Jm_Count === 0 ? "" : <p className="f_new"></p>}
                                </div>
                            </Link>
                            {this.footer_textrender("icon5", "마이페이지")}
                        </li>
                    
                </ul>
                </footer>
              
            </div>
        );
    }
}
